export function ServiceBlock({
  image,
  title,
  text,
  reverse = false,
  index,
}: {
  image: string;
  title: string;
  text: string;
  reverse?: boolean;
  index: number;
}) {
  return (
    <div
      className={` flex flex-col items-center text-center gap-5 md:gap-20  ${index < 3 ? "col-span-2" : "col-span-3"}`}
    >
      <div className="flex justify-start md:justify-center">
        <img
          src={image}
          alt={title}
          loading="lazy"
          className="h-full md:h-[120px] w-[70px] md:w-[120px] min-w-[120px] object-contain"
        />
      </div>
      <div>
        <h2 className="font-display text-xl font-extrabold text-brand-navy md:text-xl">
          {title}
        </h2>
        <p className="mt-4 leading-relaxed text-muted-foreground">{text}</p>
      </div>
    </div>
  );
}
